import script from "./NextflowTasks.vue?vue&type=script&lang=ts&setup=true"
export * from "./NextflowTasks.vue?vue&type=script&lang=ts&setup=true"

import "./NextflowTasks.vue?vue&type=style&index=0&id=8dbb7212&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dbb7212"]])

export default __exports__